import React, { useRef, useEffect } from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'

const SelectedFilterLabel = styled.strong`
  font-size: 11px;
  padding-top: 4px;
  display: block;
`

const SelectedFilters = function ({ currentFilters }) {
  const filtersRef = useRef([])

  useEffect(() => {
    filtersRef.current.forEach(el => {
      const filterElement = el
      filterElement.style.display = 'none'
      setTimeout(() => {
        if (el.getElementsByClassName('selected-filters').length > 0) {
          filterElement.style.display = 'block'
        }
      })
    })
  }, [filtersRef.current.length])

  function setRef(el, index) {
    filtersRef.current[index] = el
  }
  return (
    <>
      {currentFilters.map((item, index) => (
        <div key={item.name} ref={el => setRef(el, index)}>
          <SelectedFilterLabel>{item.name}:</SelectedFilterLabel>
          {item.filters.map((filter, idx) => {
            const FilterComponent = filter.componentType
            return (
              <FilterComponent
                /* eslint-disable-next-line react/no-array-index-key */
                key={`${idx}_${filter.title}`}
                type={filter.type}
                filterData={filter.data}
                values={filter.values}
                title={filter.title}
                info={filter.info}
                keyWord={filter.keyWord ? filter.keyWord : null}
                customTop={filter.customTop ? filter.customTop : null}
                showFilter={false}
                isSummary
              />
            )
          })}
        </div>
      ))}
    </>
  )
}

SelectedFilters.propTypes = {
  currentFilters: PropTypes.array
}

export default SelectedFilters
